const FMCGIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89404)">
      <path
        d="M28.2469 0H3.75312C1.68375 0 0 1.68375 0 3.75312V7.5H32V3.75312C32 1.68375 30.3162 0 28.2469 0ZM4.0625 4.6875C3.545 4.6875 3.125 4.2675 3.125 3.75C3.125 3.2325 3.545 2.8125 4.0625 2.8125C4.58 2.8125 5 3.2325 5 3.75C5 4.2675 4.58 4.6875 4.0625 4.6875ZM7.8125 4.6875C7.295 4.6875 6.875 4.2675 6.875 3.75C6.875 3.2325 7.295 2.8125 7.8125 2.8125C8.33 2.8125 8.75 3.2325 8.75 3.75C8.75 4.2675 8.33 4.6875 7.8125 4.6875ZM27.9375 4.6875H12.8125C12.295 4.6875 11.875 4.2675 11.875 3.75C11.875 3.2325 12.295 2.8125 12.8125 2.8125H27.9375C28.455 2.8125 28.875 3.2325 28.875 3.75C28.875 4.2675 28.455 4.6875 27.9375 4.6875Z"
        fill="white"
      />
      <path
        d="M12.8047 27.3125C13.3225 27.3125 13.7422 26.8928 13.7422 26.375C13.7422 25.8572 13.3225 25.4375 12.8047 25.4375C12.2869 25.4375 11.8672 25.8572 11.8672 26.375C11.8672 26.8928 12.2869 27.3125 12.8047 27.3125Z"
        fill="white"
      />
      <path
        d="M21.6172 27.3125C22.135 27.3125 22.5547 26.8928 22.5547 26.375C22.5547 25.8572 22.135 25.4375 21.6172 25.4375C21.0994 25.4375 20.6797 25.8572 20.6797 26.375C20.6797 26.8928 21.0994 27.3125 21.6172 27.3125Z"
        fill="white"
      />
      <path
        d="M23.0947 17.8691C23.3484 18.216 23.4191 18.6504 23.2884 19.0598L21.8516 23.561H12.2328L11.0778 18.7929V18.7904L10.7266 17.3223H22.0191C22.4491 17.3223 22.8409 17.5216 23.0947 17.8691Z"
        fill="white"
      />
      <path
        d="M0 9.375V28.2469C0 30.3162 1.68375 32 3.75312 32H28.2469C30.3162 32 32 30.3162 32 28.2469V9.375H0ZM25.0719 19.6306L23.5662 24.3475C24.1 24.8594 24.4331 25.5788 24.4331 26.375C24.4331 27.9256 23.1712 29.1875 21.6206 29.1875C20.07 29.1875 18.8081 27.9256 18.8081 26.375C18.8081 26.0456 18.8656 25.73 18.97 25.4363H15.4587C15.5631 25.73 15.6206 26.0456 15.6206 26.375C15.6206 27.9256 14.3587 29.1875 12.8081 29.1875C11.2575 29.1875 9.99562 27.9256 9.99562 26.375C9.99562 25.7356 10.21 25.1462 10.5706 24.6731L8.01625 14.0625H5.21187C4.69375 14.0625 4.27437 13.6425 4.27437 13.125C4.27437 12.6075 4.69375 12.1875 5.21187 12.1875H8.75625C9.18006 12.1834 9.57331 12.4939 9.66813 12.9069L10.2756 15.4475H22.0169C23.0519 15.4475 23.9963 15.9269 24.6069 16.7631C25.2175 17.5987 25.3869 18.6444 25.0719 19.6306Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89404">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default FMCGIcon
